import { render } from "./ProfileEditGeneral.vue?vue&type=template&id=567e39c7"
import script from "./ProfileEditGeneral.vue?vue&type=script&lang=js"
export * from "./ProfileEditGeneral.vue?vue&type=script&lang=js"

import "./ProfileEditGeneral.vue?vue&type=style&index=0&id=567e39c7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__